import { COMPLIANCE_STATES, READINESS_STATES } from './constants';
import type { Rng } from './rng';

export function mostlyConforme(rng: Rng): (typeof COMPLIANCE_STATES)[number] {
  const [conforme, nonConforme] = COMPLIANCE_STATES;
  return rng() > 0.25 ? conforme : nonConforme;
}

export function readinessStatus(rng: Rng): (typeof READINESS_STATES)[number] {
  const [corretta, nonCorretta] = READINESS_STATES;
  return rng() > 0.75 ? nonCorretta : corretta;
}
